<div class="plan-info">
    <div class="plan-title">
        <span>
            {{plan?.planName}}
            @if (currentPlan?.transactionStatus === TRANSACTION_STATUS.PENDING && !isTrial) {
                <span> ({{ 'plan.pendingPurchase' | transloco }})</span>
            }
        </span>
        @if (plan?.isActive) {
            <span class="vehicles">{{ 'plan.vehiclesCount' | transloco: { current: plan?.limits?.vehicles?.current, max: plan?.limits?.vehicles?.maximum } }}</span>
        }
    </div>
    
    @if (plan?.isActive) {
        <div class="progress-bar">
            <div class="progress-fill" [style.width.%]="vehiclesProgress"></div>
        </div>
    }
    @if (isTrial) {
        <div class="trial-info">
            <span class="trial-badge" [class.expiring-soon]="isTrialExpiringSoon">
                {{ 'plan.trialBadge' | transloco: { status: getTrialStatusText() } }}
            </span>
        </div>
    }
    
    @if (!onlyCurrentPlan) {
        <button class="btn-general" (click)="navigate()">
            <i class="pi pi-bolt"></i> {{ 'plan.viewPlansButton' | transloco }}
        </button>
    }
</div>